import React, { useState, useEffect } from 'react';
import { get } from '../core/http';
import { API } from '../core/constants';
import { Link } from 'react-router-dom';
import CategoryForm from './CategoryForm';
import PageHeader from './ui/PageHeader';

import CIcon from '@coreui/icons-react';
import * as icon from '@coreui/icons';

const Categories = () => {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedCategory, setSelectedCategory] = useState();
  const [visible, setVisible] = useState();

  const getCategories = async () => {
    try {
      const result = await get(`${API}/categories`);

      if (result.body) {
        setCategories((curr) => result.body);
      }
    } catch (error) {
      console.log('Could not retrieve events');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getCategories();
  }, []);

  const addNewCategory = () => {
    setSelectedCategory(null);
    setVisible(true);
  };
  const editCategory = (category) => {
    setSelectedCategory(category);
    setVisible(true);
  };
  const handleFormSubmit = (event) => {
    getCategories();
    setSelectedCategory(null);
    setVisible(false);
  };

  return (
    <>
      <PageHeader
        title="Categories"
        count={!loading ? categories.length : null}
        actions={
          <button className="btn btn-primary btn-sm" onClick={() => addNewCategory()}>
            Add new
          </button>
        }
      />

      {!loading && !categories.length ? (
        <p className="text-center text-sm text-base-content/60 py-10">No categories yet</p>
      ) : (
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-3">
        {categories.map((category) => (
          <div key={category.id} className="bg-base-100 border border-base-300 rounded-lg p-3 flex flex-col items-center text-center gap-1.5">
            <CIcon icon={icon['cil' + category.icon]} className="w-5 h-5 text-base-content/70" />
            <h2 className="text-sm font-medium leading-tight">{category.title}</h2>
            <div className="flex gap-1 mt-1">
              <button onClick={() => editCategory(category)} className="btn btn-secondary btn-xs">
                Edit
              </button>
              <Link to={`/?categoryId=${category.id}`} className="btn btn-ghost btn-xs">
                Events
              </Link>
            </div>
          </div>
        ))}
      </div>
      )}
      {visible && <CategoryForm category={selectedCategory} onFormSubmit={handleFormSubmit} onCancel={() => setVisible(false)} />}
    </>
  );
};

export default Categories;
